import { createFileRoute } from "@tanstack/react-router";

import SupportPage from "@/admin/support/page";

export const Route = createFileRoute("/app/$storeId/support")({
    component: RouteComponent,
});

function RouteComponent() {
    return <SupportPage />;
}
